import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.for-each";

var IFramePool =
/** @class */
function () {
  function IFramePool(options) {
    if (options === void 0) {
      options = {};
    }

    this.pool = [];
    this.isWrapperCreated = false;
    this.wrapper = options.wrapper || this.createWrapper();
  }
  /**
   * 从池子从获取一个 iframe 并运行任务
   * @param job 要运行的任务, 参数为获取到的 iframe 对象. 若有异步任务, 必须返回 Promise
   * @returns 任务运行结果
   */


  IFramePool.prototype.run = function (job) {
    var item = this.getItem();
    var previousPromise = item.promise || Promise.resolve();
    item.promise = previousPromise.then(function () {
      return job(item.iframe);
    }).then(function (result) {
      item.promise = null;
      return result;
    });
    return item.promise;
  };
  /** 在 iframe 中加载一个 url, 并等待其加载完成 */


  IFramePool.prototype.load = function (url) {
    return this.run(function (iframe) {
      return new Promise(function (resolve) {
        // iframe 不会有 onerror 事件, 所以只能 resolve
        // https://stackoverflow.com/questions/52639526/using-onerror-on-an-iframe
        iframe.onload = function () {
          return resolve(iframe);
        };

        iframe.src = url;
      });
    });
  };
  /** 销毁池子, 删除所有 iframe */


  IFramePool.prototype.destroy = function () {
    var _this = this;

    if (this.isWrapperCreated) {
      document.body.removeChild(this.wrapper);
    }

    this.pool.forEach(function (_a) {
      var iframe = _a.iframe;

      _this.wrapper.removeChild(iframe);
    }); // @ts-ignore
    // eslint-disable-next-line no-multi-assign

    this.wrapper = this.pool = null;
  };
  /**
   * 创建一个 wrapper
   * @protected
   */


  IFramePool.prototype.createWrapper = function () {
    var div = document.createElement("div");
    this.hideElement(div);
    document.body.appendChild(div);
    this.isWrapperCreated = true;
    return div;
  };
  /**
   * 创建一个 iframe
   * @protected
   */


  IFramePool.prototype.createIFrame = function () {
    var iframe = document.createElement("iframe");
    this.hideElement(iframe);
    this.wrapper.appendChild(iframe);
    return iframe;
  };
  /**
   * 从池子从获取一个 iframe
   * @protected
   * @description 目前只获取空闲的 iframe, 未来有可能返回正在执行的
   */


  IFramePool.prototype.getItem = function () {
    for (var i = 0; i < this.pool.length; i++) {
      if (!this.pool[i].promise) {
        return this.pool[i];
      }
    }

    return this.expandItem();
  };
  /**
   * 扩容池子, 增加一个 iframe
   * @protected
   */


  IFramePool.prototype.expandItem = function () {
    var item = {
      iframe: this.createIFrame(),
      promise: null
    };
    this.pool.push(item);
    return item;
  };
  /**
   * 使用 css 强行隐藏某个元素
   * @protected
   */


  IFramePool.prototype.hideElement = function (el) {
    el.style.cssText = "display:none;position:absolute;left:0;top:0;width:0;height:0;visibility:hidden";
  };

  return IFramePool;
}();

export { IFramePool };